// import images
import Logo from '../src/img/header/logo.svg';
// import GalleryImg1 from '../src/img/gallery/1.png';
// import GalleryImg2 from '../src/img/gallery/2.png';
import GalleryImg3 from '../src/img/gallery/3.png';
import GalleryImg4 from '../src/img/gallery/4.png';
import GalleryImg5 from '../src/img/gallery/5.png';
import GalleryImg6 from '../src/img/gallery/6.png';
import GalleryImg7 from '../src/img/gallery/7.png';
import GalleryImg8 from '../src/img/gallery/8.png';
import GalleryImg9 from '../src/img/gallery/9.png';
import GalleryImg10 from '../src/img/gallery/10.png';
import GalleryImg11 from '../src/img/gallery/11.png';
import GalleryImg12 from '../src/img/gallery/12.png';
import GalleryImg13 from '../src/img/gallery/13.png';
import GalleryImg14 from '../src/img/gallery/14.png';
import GalleryImg15 from '../src/img/gallery/15.png';
import GalleryImg16 from '../src/img/gallery/16.png';
// tribute images 
import TributeImg1 from '../src/img/tributeImage/1.jpg';
import TributeImg2 from '../src/img/tributeImage/2.jpg';
import TributeImg3 from '../src/img/tributeImage/3.jpg';
import TributeImg4 from '../src/img/tributeImage/4.jpg';
import TributeImg5 from '../src/img/tributeImage/5.jpg';
import TributeImg6 from '../src/img/tributeImage/6.jpg';
import TributeImg7 from '../src/img/tributeImage/7.jpg';
import TributeImg8 from '../src/img/tributeImage/8.jpg';
import TributeImg9 from '../src/img/tributeImage/9.jpg';
import TributeImg10 from '../src/img/tributeImage/10.jpg';
// import Project images
import almond from '../src/img/projectsImage/almond.jpg'
import octa from '../src/img/projectsImage/octa.jpg'
import basantidhaba from '../src/img/projectsImage/basantidhaba.jpg'
import chai from '../src/img/projectsImage/chai.jpg'
import convroom from '../src/img/projectsImage/convroom.jpg'
import itc from '../src/img/projectsImage/itc.jpg'
import kothari from '../src/img/projectsImage/kothari.jpg'
import meraqi from '../src/img/projectsImage/meraqi.jpg'
import parkstreet from '../src/img/projectsImage/parkstreet.jpg'
import regus from '../src/img/projectsImage/regus.jpg'


import QuoteImg from '../src/img/testimonial/quote.svg';
// import icons
// import { GrFacebookOption } from 'react-icons/gr';
import { IoLogoWhatsapp, IoMdArrowForward } from 'react-icons/io';
import { FiSend } from 'react-icons/fi';
import { FaMapMarkerAlt, FaPhoneAlt, FaEnvelope } from 'react-icons/fa';
import {
  IoLogoInstagram,
  // IoLogoPinterest,
  // IoLogoWhatsapp,
  // IoLogoTwitter,
  // IoLogoYoutube,
} from 'react-icons/io';

export const headerData = {
  logo: Logo,
};

// export const navData = {
//   items: [
//     { href: '/', name: 'Home' },                   // Route for Home
//     { href: '/about', name: 'About' },            // Route for About section
//     { href: '/project', name: 'Project' },        // Route for Project section
//     { 
//       href: 'https://acrobat.adobe.com/id/urn:aaid:sc:AP:a607cdc2-7251-4338-a012-3879590a04a1', 
//       name: 'Catalogue', 
//       target: '_blank'                            // External link with new tab
//     },
//     { href: '/services', name: 'Services' },      // Route for Services section
//     { href: '/contact', name: 'Contact' },        // Route for Contact section
//   ],
// };

export const navData = {
  items: [
    { href: '/', name: 'Home' },
    { href: '#about', name: 'About' },
    { href: '/project', name: 'Project' },
    { href: 'https://acrobat.adobe.com/id/urn:aaid:sc:AP:a605c380-8674-4ad7-a479-527b52e01971', name: 'Catalogue', target:'_blank'},
    { href: '#services', name: 'Services' },
    { href: '#testimonials', name: 'Testimonials' },
    { href: '#contact', name: 'Contact' },
  ],
};

export const socialData = [
  // { href: 'https://www.facebook.com/salimarts39?mibextid=ZbWKwL', icon: <GrFacebookOption /> },
  { href: 'https://www.instagram.com/salim_arts_signs?igsh=cjFrcWFqOWkycnVt', icon: <IoLogoInstagram /> },
  // { href: '/', icon: <IoLogoPinterest /> },
  { href: 'https://wa.me/9051306786', icon: <IoLogoWhatsapp /> },
  // { href: '/', icon: <IoLogoTwitter /> },
  // { href: '/', icon: <IoLogoYoutube /> },
];

export const heroData = {
  title: "We're Salimarts Sign board Makers.",
  subtitle:
    'The Leading Brand in Signage Industry.',
  btnText: 'read more',
  btnIcon: <IoMdArrowForward />,
};

export const aboutData = {
  title: 'Our Story:',
  subtitle1:
    'Welcome to our sign age agency, where creativity meets communication. Our team of skilled designers and craftsmen are dedicated to delivering innovative solutions for business and individuals. Our signage agency offers a diverse range of materials including neon for vibrant illumination, vinyl for crisp graphics, ACP for durability, and flex for versatility.',
  subtitle2:
    'SALIM ARTS signage provider brings with it a revolutionary idea that will hit the advertising display segment by changing the face of the existing signage dynamics forever and ever.',
  btnText: 'Know more',
  btnIcon: <IoMdArrowForward />,
};

export const galleryData = {
  title: 'Check Our gallery:',
  btnText: 'View all',
  btnIcon: <IoMdArrowForward />,
  images: [
    // {
    //   src: GalleryImg1,
    //   original: GalleryImg1,
    //   width: 465,
    //   height: 412,
    // },
    // {
    //   src: GalleryImg2,
    //   original: GalleryImg2,
    //   width: 465,
    //   height: 540,
    // },
    {
      src: GalleryImg3,
      original: GalleryImg3,
      width: 465,
      height: 412,
    },
    {
      src: GalleryImg4,
      original: GalleryImg4,
      width: 475,
      height: 540,
    },
    {
      src: GalleryImg5,
      original: GalleryImg5,
      width: 485,
      height: 540,
    },
    {
      src: GalleryImg6,
      original: GalleryImg6,
      width: 464,
      height: 412,
    },
    {
      src: GalleryImg7,
      original: GalleryImg7,
      width: 465,
      height: 540,
    },
    {
      src: GalleryImg8,
      original: GalleryImg8,
      width: 465,
      height: 412,
    },
    {
      src: GalleryImg9,
      original: GalleryImg9,
      width: 465,
      height: 412,
    },
    {
      src: GalleryImg10,
      original: GalleryImg10,
      width: 465,
      height: 412,
    },
    {
      src: GalleryImg11,
      original: GalleryImg11,
      width: 465,
      height: 412,
    },
    {
      src: GalleryImg12,
      original: GalleryImg12,
      width: 465,
      height: 412,
    },
    {
      src: GalleryImg13,
      original: GalleryImg13,
      width: 465,
      height: 412,
    },
    {
      src: GalleryImg14,
      original: GalleryImg14,
      width: 465,
      height: 412,
    },
    {
      src: GalleryImg15,
      original: GalleryImg15,
      width: 465,
      height: 412,
    },
    {
      src: GalleryImg16,
      original: GalleryImg16,
      width: 465,
      height: 412,
    },
  ],
};

// export const interviewData = {
//   title:
//     '“Consider what you desire. Your sign board is your Hero.”',
//   btnText: 'Watch it now',
//   btnIcon: <FaPlay />,
// };

export const tributeData = {
  title: 'Tribute to our Working partners:',
  subtitle: 'At SALIM ARTS, we are proud to have a dedicated team of skilled workers and trusted partners who consistently deliver exceptional signage services, no matter the challenges. Whether facing seasonal fluctuations or tough working conditions, our team remains committed to maintaining the highest standards of quality and efficiency.Their unwavering dedication and resilience ensure that every project, big or small, is completed on time and to perfection. We deeply value their hard work and reliability, as they are integral to our success and our ability to serve our clients with excellence.',
  // btnText: 'View all',
  // btnIcon: <IoMdArrowForward />,
  images: [
    {
      src: TributeImg1,
      original: TributeImg1,
      width: 485,
      height: 440,
    },
    {
      src: TributeImg2,
      original: TributeImg2,
      width: 485,
      height: 520,
    },
    {
      src: TributeImg3,
      original: TributeImg3,
      width: 485,
      height: 540,
    },
    {
      src: TributeImg4,
      original: TributeImg4,
      width: 485,
      height: 540,
    },
    {
      src: TributeImg5,
      original: TributeImg5,
      width: 485,
      height: 540,
    },
    {
      src: TributeImg6,
      original: TributeImg6,
      width: 485,
      height: 540,
    },
    {
      src: TributeImg7,
      original: TributeImg7,
      width: 485,
      height: 540,
    },
    {
      src: TributeImg8,
      original: TributeImg8,
      width: 485,
      height: 540,
    },
    {
      src: TributeImg9,
      original: TributeImg9,
      width: 485,
      height: 540,
    },
    {
      src: TributeImg10,
      original: TributeImg10,
      width: 485,
      height: 540,
    },
  ],
};

export const projectsData = [
  {
    // image: '../img/projectsImage/almond.jpg',
    src: almond,
    title: "The Almond Banquet",
    description:
      "The Almond Banquet, nestled in the heart of Salt Lake City, Kolkata, is a stunning venue renowned for its elegance and sophistication, making every occasion memorable. Salim Arts had the privilege of crafting bespoke signage for The Almond, enhancing its premium ambiance with our expertise in signage solutions.",
  },
  {
    src: kothari,
    title: "Kothari Medical Centre",
    description:
      "Kothari Medical Centre, a prestigious hospital in Alipore, Kolkata, is renowned for its exceptional healthcare services and state-of-the-art facilities. Salim Arts had the honor of providing signage solutions for Kothari Medical Centre, ensuring a perfect blend of functionality and aesthetic appeal to match its esteemed reputation.",
  },
  {
    src: basantidhaba,
    title: "Rang De Basanti Dhaba",
    description:
      "Rang De Basanti Dhaba, with its vibrant presence across Sector V, Bypass, Diamond Plaza Mall, and several other locations in Kolkata, is a renowned restaurant celebrated for its authentic flavors and lively ambiance. Salim Arts had the privilege of designing impactful signage for Rang De Basanti Dhaba, adding to its iconic charm and inviting atmosphere." ,
  },
  {
    src: octa,
    title: "Octa",
    description:
      "Octa, a chic restaurant, bar, and cafe in the heart of Park Street, Kolkata, is known for its modern vibes and luxurious ambiance. Salim Arts contributed by crafting signage that seamlessly reflected Octa's sophisticated and vibrant essence, enhancing its appeal as a premium destination.",
  },
  {
    src: itc,
    title: "ITC Infotech",
    description:
      "ITC Infotech, a premier IT solutions company in Kolkata, is recognized for its innovative technology services and unwavering commitment to excellence. Salim Arts collaborated with ITC Infotech to design signage that complements their modern workspace, enhancing their corporate presence",
  },
  {
    src: convroom,
    title: "Conversation Room",
    description:
      "Conversation Room, located on Chowringee Road, is a bar and restaurant known for its modern yet welcoming ambiance. Salim Arts created signage that perfectly complements its stylish and sophisticated vibe, enhancing its overall appeal.",
  },
  {
    src: parkstreet,
    title: "Park Street",
    description:
      "Park Street Social, a vibrant bar and restaurant located in the heart of Kolkata's bustling Park Street, is known for its energetic ambiance and trendy decor. Salim Arts enhanced its appeal by crafting stunning neon signage that perfectly reflects its lively and modern vibe.",
  },
  {
    src: regus,
    title: "Regus",
    description:
      "Regus, a British company and leading workspace provider, offers flexible office solutions in prime locations. In Kolkata, their modern office spaces are elevated by eye-catching signage crafted by Salim Arts, capturing the brand's professional and dynamic essence",
  },
  {
    src: meraqi,
    title: "Meraqi",
    description:
      "Meraqi Digital, a renowned graphic designing company, is known for its creative and innovative approach to design. Their office, located in the heart of Kolkata, is complemented by striking signage crafted by Salim Arts, which reflects their artistic and contemporary brand identity.",
  },
  {
    src: chai,
    title: "Chai Break",
    description:
      "Chai Break, a popular café with locations in Sambalpur, Odisha, and Girish Park, Kolkata, offers a cozy and inviting atmosphere for tea lovers. The cafés are made even more charming with vibrant signage created by Salim Arts, enhancing their warm and welcoming vibe.",
  },
];

export const testimonialData = [
  {
    quoteImg: QuoteImg,
    message:
      "Great Job done. The work was completed in record time. And the Brightness of Channel letters and the Vinyl Background design surpassed our expectations. Hugely recommended.",
    name: 'Atanu Bhattacharyaa',
    occupation: 'K C DAS',
  },
  {
    quoteImg: QuoteImg,
    message:
      "Salim Art's meticulous work and execution has been a delight. Our artworks turn out exactly how we envision them.",
    name: 'Vidushi Kedia',
    occupation: 'Atelier2332',
  },
   {
    quoteImg: QuoteImg,
    message:
      "I am attached with them since last 10 years. I appreciate their creative ideas and signboard job finishing and on time delivery. They are very much committed to their service. I would highly recommend them for any signage related job. They both Salim bhai and his team along with his son all are too good.",
    name: 'Rahul Jadhav',
    occupation: 'Rahul Jwellery Creations',
  },
  {
    quoteImg: QuoteImg,
    message:
      "Salim Art's time commitment, the designing, finishing of work and the pricing is FANTASTIC!",
    name: 'Vikash Bajaj',
    occupation: 'Pratham Boutique',
  },
  {
    quoteImg: QuoteImg,
    message:
      "It's been over four years since we started working with Salim Arts.Their top-notch work reflects their attention to detail and dedication to excellence. Their proactive approach truly sets them apart—they always develop fresh ideas and valuable suggestions that enhance our brand visibility. They're incredibly prompt, ensuring deadlines are met without compromise.",
    name: 'Anjali Thacker',
    occupation: 'Rang De Basanti Dhaba',
  },
  {
    quoteImg: QuoteImg,
    message:
      'We recently had a silver signboard created, and the results were nothing short of outstanding! The craftsmanship was impeccable, with every detail perfectly executed. The finish on the silver surface exudes elegance and professionalism, making it the ideal choice for our business.',
    name: 'Ritvik Madhogaria',
    occupation: 'Madhogaria Silver art',
  },
];

export const contactData = {
  title: 'Get in touch with us:',
  info: [
    {
      title: 'The office',
      subtitle:
        'Welcome to our sign age agency, where creativity meets communication.',
      address: {
        icon: <FaMapMarkerAlt />,
        name: '26, Robert Street, Bowbazar, Kolkata, West Bengal 700012',
      },
      phone: {
        icon: <FaPhoneAlt />,
        number: '+91 9051306786/ +91 7044728999/ +91 8910948850',
      },
      email: {
        icon: <FaEnvelope />,
        address: 'business@salimartssignage.com',
      },
      link: 'Get location',
    },
    // {
    //   title: 'NYC office',
    //   subtitle:
    //     'Sit amet, consectetur nun in velit arcu posuere integer. Adipiscing elit duis porttitor massa tellus',
    //   address: {
    //     icon: <FaMapMarkerAlt />,
    //     name: '1630 Elm Drive, New York City',
    //   },
    //   phone: {
    //     icon: <FaPhoneAlt />,
    //     number: '+49 34 36573355',
    //   },
    //   email: {
    //     icon: <FaEnvelope />,
    //     address: 'contact@yourcompany.com',
    //   },
    //   link: 'Get location',
    // },
  ],
  form: {
    name: 'Write your name here',
    phone: 'Write your phone number',
    email: 'Write your email address',
    message: 'Write your messages here',
    btnText: 'Send it',
  },
};

export const footerData = {
  about: {
    title: 'About Salim arts',
    subtitle:
      'SALIM ARTS, founded in 2016 by Mohammed Salim, combines decades of his experience in the signage industry. The company is renowned for its innovative approach and adaptability to changing trends.',
    subtitle2: 'The office', 
    address: {
      icon: <FaMapMarkerAlt />,
      name: '26, Robert Street, Bowbazar, Kolkata, West Bengal 700012',
    },
    phone: {
      icon: <FaPhoneAlt />,
      number: '+91 9051306786/ +91 7044728999/ +91 8910948850',
    },
    email: {
      icon: <FaEnvelope />,
      address: 'business@salimartssignage.com',
    },
  },
  links: {
    title: 'Useful links',
    items: [
      { href: '#about', name: 'About us' },
      { href: '#gallery', name: 'Our gallery' },
      { href: '#services', name: 'Our services' },
      { href: '#contact', name: 'Contact us' },
    ],
  },
  program: {
    title: 'Working Time',
    items: [
      { name: 'Mon - Tue / 10:00 - 8:00pm' },
      { name: 'Wed - Sat / 10:00 - 7:00pm' },
      // { name: 'Sat / 10:00 - 6:00pm' },
      { name: 'Sun / 10:00 - 2:00pm' },
    ],
  },
  newsletter: {
    title: 'Newsletter',
    subtitle:
      'Elit duis porttitor massa tellus nun in velit arcu posuere integer.',
    form: {
      placeholder: 'Your email address',
      icon: <FiSend />,
    },
  },
};
